export default {
      id: "oc-res-strategy-usage",
      viewBox: "0 0 1366 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-strategy",
      toString: function () {
        return this.url;
      }
    }